<template>
  <el-container>
    <el-header height="56px">
      <Header></Header>
    </el-header>
    <el-container>
      <el-aside width="216px">
        <el-menu
          router
          :default-active="getActiveRouter()"
          background-color="#1e1f23"
          text-color="#999ea8"
          active-text-color="#fff"
        >
          <AsideMenu v-for="(item, index) in menuItems" :key="index" :item="item" />
        </el-menu>
      </el-aside>
      <el-main height="">
        <HeaderBoard
          v-if="breadMeta"
          :title="breadMeta.title"
          :items="breadMeta.breadcrumb"
          :description="breadMeta.description"
          :back="breadMeta.back"
        ></HeaderBoard>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AsideMenu from './AsideMenu.vue'
import HeaderBoard from './HeaderBoard.vue'
import menusConfig from './menusConfig'
import headerIcon from '@/assets/images/frame_logo.png'
import Header from './Header.vue'
export default {
  name: 'BasicContainer',

  components: {
    Header,
    AsideMenu,
    HeaderBoard,
  },
  data() {
    return {
      headerIcon,
      env: process.env.VUE_APP_BUILD,
    }
  },
  computed: {
    menuItems() {
      return menusConfig()
    },

    breadMeta() {
      const { meta } = this.$route
      return meta
        ? {
            title: meta.title,
            breadcrumb: meta.breadcrumb,
            description: meta.description,
            back: meta.back,
          }
        : null
    },
  },

  methods: {
    getActiveRouter() {
      const { meta, name } = this.$route
      return meta.active || name
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-aside {
  height: 100%;
}
::v-deep .el-header {
  padding: 0;
}
</style>
